import {
    AppBlogEndpointType,
    AppCatalogEndpointType,
    AppDocumentationEndpointType,
    AppEndpoints,
    AppLogbookEndpointType,
    AppResourcesEndpointType,
    AppRolEndpointType,
    AppSarenvEndpointType,
    AppSarTicketsEndpointType,
    AppThirdPartyEndpointType,
    AppUserEndpointType,
    AppWorkspaceEndpointType
} from "../types";
import {
    loginConfig,
    requestConfig,
    requestConfigForm,
    sartokenConfig,
    swaggerConfig
} from "./contants.config";

const thirdPartyEndpoints: AppThirdPartyEndpointType = {
    login: {
        url: "/identity/authremota/authenticate",
        method: "POST",
        name: "Inicio de sesión",
        config: loginConfig,
        thirdParty: true
    },
    getApiList: {
        url: `/{origin}?page={groupId}&limit=5000&sort=NAME&order=ASC`,
        method: "GET",
        name: "Listar API",
        config: swaggerConfig,
        thirdParty: true
    },
    validarCurp: {
        url: `/sartoken/transversales/web/consultarcurpbeneficiario`,
        method: "POST",
        name: "Validación de curp",
        config: sartokenConfig,
        thirdParty: true
    },
    consultarCatalogoEstados: {
        url: `/sartoken/transversales/web/consultarcatalogos`,
        method: "POST",
        name: "Consultar catalogo",
        config: sartokenConfig,
        thirdParty: true
    },
}

const userEndpoints: AppUserEndpointType = {
    getUserMenu: { url: "/portal/acceso", method: "GET", name: "Acceso usuario" },
    getNotifications: { url: '/notificaciones', method: 'GET', name: 'Listar notificaciones' },
    updateNotification: { url: '/notificaciones/actualizar', method: 'GET', name: 'Actualizar notificación' },
    subscribePushNotification: { url: '/notificaciones/suscribir', method: 'POST', name: 'Suscribir a notificaciones' },
    updateAllNotification: { url: '/notificaciones/actualizarTodas', method: 'GET', name: 'Confirmación de todas las notificaciones' }
}

const rolEndpoints: AppRolEndpointType = {
    getRoles: { url: '/usuarios/roles', method: 'POST', name: 'Listar roles' },
    addRol: { url: '/usuarios/roles/agregar', method: 'POST', name: 'Agregar rol' },
    editRol: { url: '/usuarios/roles/editar', method: 'POST', name: 'Editar rol' },
    getUsers: { url: '/usuarios/listar', method: 'POST', name: 'Listar usuarios' },
    setUser: { url: '/usuarios/asociar', method: 'POST', name: 'Agregar usuario' },
    updateUserDataPart: { url: '/usuarios/datoParticular', method: 'POST', name: 'Actualizar dato particular' },
    deleteUserDataPart: { url: '/usuarios/datoParticular/eliminar', method: 'POST', name: 'Eliminar dato particular' },
    addMenu: { url: '/usuarios/menu/agregar', method: 'POST', name: 'Agregar menú' },
    editMenu: { url: '/usuarios/menu/editar', method: 'POST', name: 'Editar menú' },
    changeMenuStatus: { url: '/usuarios/menu/estatus', method: 'POST', name: 'Cambiar estatus menú' },
    deleteMenu: { url: '/usuarios/menu/eliminar', method: 'POST', name: 'Elimina menú' },
    updateRolResources: { url: '/usuarios/roles/recurso', method: 'POST', name: 'Actualiza recursos global' },
}

const catalogsEndpoints: AppCatalogEndpointType = {
    getAppBase: { url: "/catalogo/base", method: "GET", name: "Recupera catalogos de aplicación" },
    getGroups: { url: "/catalogo/particular", method: "GET", name: "Recupera catalogos operativos" },
    add: { url: '/catalogo/particular/{groupId}/agregar', method: 'POST', name: 'Agrega opción generica' },
    delete: { url: '/catalogo/particular/{groupId}/eliminar', method: 'POST', name: 'Actualiza catalogo generico' },
    edit: { url: '/catalogo/particular/{groupId}/editar', method: 'POST', name: 'Edita catalogo generico' },
    update: { url: '/catalogo/particular/{groupId}/actualizar', method: 'POST', name: 'Actualiza catalogo generico' }
}

const workspaceEnpoints: AppWorkspaceEndpointType = {
    getCredentials: { url: "/workspace", method: "POST", name: "Listar credenciales" },
    addCredentials: { url: "/workspace/agregar", method: "POST", name: "Agregar credenciales" },
    editCredentials: { url: "/workspace/editar", method: "POST", name: "Editar credenciales" },
    deleteCredentials: { url: "/workspace/eliminar", method: "POST", name: "Eliminar credenciales" },
    addRepository: { url: `/workspace/repositorios`, method: "POST", name: "Agregar repositorio" },
    editRepository: { url: `/workspace/repositorios/editar`, method: "POST", name: "Editar repositorio" },
    deleteRepository: { url: `/workspace/repositorios/eliminar`, method: "POST", name: "Eliminar repositorio" },
}

const resourcesEnpoints: AppResourcesEndpointType = {
    getResourcesBySubtype: { url: `/recursos/subtipo`, method: "GET", name: "Listar recursos" },
    getResourcesByName: { url: `/recursos/busca`, method: "GET", name: "Busca recurso" },
    getResourcesByRol: { url: `/recursos/rol`, method: "GET", name: "Listar recurso" },
    addResource: { url: `/recursos`, method: "POST", name: "Agregar recursos", config: requestConfigForm },
    linkResources: { url: `/recursos/asociar`, method: "POST", name: "Vincular recursos" },
    editResource: { url: `/recursos/editar`, method: "POST", name: "Editar recurso" },
    deleteResource: { url: `/recursos/eliminar`, method: "POST", name: "Eliminar recursos" },
    addVersion: { url: `/recursos/version`, method: "POST", name: "Agregar versión", config: requestConfigForm },
    editVersion: { url: `/recursos/version/editar`, method: "POST", name: "Agregar versión", config: requestConfigForm },
    deleteVersion: { url: `/recursos/version/eliminar`, method: "POST", name: "Eliminar versión" },
    deleteArtifact: { url: `/recursos/artefacto/eliminar`, method: "POST", name: "Eliminar artefacto" },
    downloadArtifact: {
        url: `/recursos/artefacto`,
        method: "GET",
        name: "Descargar recurso",
        config: { ...requestConfig, responseType: 'blob' }
    }
}

const documentationEndpoints: AppDocumentationEndpointType = {
    publicResource: { url: `/referencias/adjuntos/inicio`, method: "GET", name: "Consulta inicio" },
    referencedDocument: { url: `/referencias/documento`, method: "GET", name: "Consulta documento" },
    listComments: { url: `/referencias/documento/comentarios`, method: "GET", name: "Consulta comentarios" },
    addComment: { url: `/referencias/documento/comentarios/agregar`, method: "POST", name: "Agrega comentario" },
    editComment: { url: `/referencias/documento/comentarios/editar`, method: "POST", name: "Edita comentario" },
    deleteComment: { url: `/referencias/documento/comentarios/eliminar`, method: "POST", name: "Elimina comentario" },
    createCommentResource: { url: `/referencias/documento/recurso`, method: "POST", name: "Genera comentario recurso" }
}

const blogEndpoints: AppBlogEndpointType = {
    getBlogEntries: { url: `/blog`, method: "GET", name: "Consulta entradas" },
    addBlogEntry: { url: `/blog/agregar`, method: "POST", name: "Agrega entrada" },
    editBlogEntry: { url: `/blog/editar`, method: "POST", name: "Edita entrada" },
    deleteBlogEntry: { url: `/blog/eliminar`, method: "POST", name: "Elimina entrada" }
}

const logbookEndpoints: AppLogbookEndpointType = {
    listaSartokenServicios: { url: `/bitacora/sartoken/servicios`, method: "GET", name: "Consulta lista de servicios de bitacora Sartoken" },
    consultaBitacoraApp: { url: `/bitacora/sartoken/bitacoraServicio`, method: "POST", name: "Consulta de bitacora de servicios Sartoken" },
    detalleBitacoraApp: { url: `/bitacora/sartoken/bitacoraDetalle`, method: "POST", name: "Consulta detalle de registro bitacora Sartoken" },
    consultaCodSegApp: { url: `/bitacora/sartoken/bitacoraSms`, method: "POST", name: "Consulta de bitacora sms de Sartoken" },
    consultaBitacoraAmbientacion: { url: `/bitacora/ambientacion`, method: "POST", name: "Consulta de bitacora de ambientación" }
}

const sarenvEndpoints: AppSarenvEndpointType = {
    ambientacionPerfil: { url: `/ambientacion/perfil`, method: "POST", name: "Ambientación de perfil", config: requestConfigForm },
}

const ticketsEndpoints: AppSarTicketsEndpointType = {
    credencialesJira: { url: `/tickets/credenciales`, method: "POST", name: "Lista credenciales Jira" },
    listaProyectos:{ url: `/tickets/proyectos`, method: "POST", name: "Lista proyectos Jira" },
    eliminaCredencial: { url: `/tickets/credenciales/eliminar`, method: "POST", name: "Elimina credencial Jira" },
    registraCredencial:  { url: `/tickets/credenciales/agregar`, method: "POST", name: "Agrega credencial Jira" },
    editaCredencial:  { url: `/tickets/credenciales/editar`, method: "POST", name: "Edita credencial Jira" },
    iconoProyecto:  { url: `/tickets/operacion/avatar`, method: "GET", name: "Recupera icono proyecto" },
    tiposTicket:  { url: `/tickets/proyectos/tipoIssues`, method: "POST", name: "Lista tipos de ticket del tablero" },
    tipoTicketWorkflow:  { url: `/tickets/proyectos/tipoIssues/workflow`, method: "POST", name: "Consulta de workflow" },
    fijarDashboard:  { url: `/tickets/proyectos/fijar`, method: "POST", name: "Fijar tablero" },
    retirarFijado:  { url: `/tickets/proyectos/retirarFijado`, method: "POST", name: "Fijar tablero" },
    listarIssues:  { url: `/tickets/operacion/issues`, method: "POST", name: "Listar issues" },
    enviarIssue: { url: `/tickets/operacion/issues/crear`, method: "POST", name: "Enviar issue", config: requestConfigForm  },
    detalleIssue:  { url: `/tickets/operacion/issues/detalle/{origin}`, method: "GET", name: "Detalle issue" },
    adjuntoIssue:  { url: `/tickets/operacion/issues/media`, method: "GET", name: "Recupera adjunto issue" },
    comentaIssue: { url: `/tickets/operacion/issues/comentario`, method: "POST", name: "Comenta issue", config: requestConfigForm  },
}

export const webApiEndpoints: AppEndpoints = {
    blog: blogEndpoints,
    catalog: catalogsEndpoints,
    documentation: documentationEndpoints,
    resources: resourcesEnpoints,
    rol: rolEndpoints,
    thirdParty: thirdPartyEndpoints,
    user: userEndpoints,
    workspace: workspaceEnpoints,
    logbook: logbookEndpoints,
    sarenv: sarenvEndpoints,
    tickets: ticketsEndpoints
}